import { json2csv } from 'json-2-csv';
import store from 'store';

export function makeVerbose(items) {
  const fullForms = {
    o: "Timely",
    n: "-",
    m: "Missed",
    d: "Delayed",
    ex: "Exempted"
  };
  for (let item of items) {
    for (let key in item) {
      item[key] = fullForms[item[key]] || item[key];
    }
  }
  return items;
}

export function StringifySingleStati(temp, timestamp) {
  return `${temp.Fajr},${temp.Zuhr},${temp.Asr},${temp.Maghrib},${temp.Isha},${new Date(timestamp || temp.timestamp).getTime()}`
}

export function ParseSingleStringifiedStati(temp, isVerbose) {
  const parts = temp.split(',');
  return {
    Fajr: parts[0], //make verbose
    Zuhr: parts[1],
    Asr: parts[2],
    Maghrib: parts[3],
    Isha: parts[4],
    timestamp: new Date(parseInt(parts[5])).toISOString(),
  }
}

function download(filename, text) {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
  element.setAttribute('download', filename);
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
  alert("Downloaded all of your data as a .csv file")
}

export const printAllData = () => {
  if (window.confirm("This is an experimental feature. If you notice errors in the file generated, please report them"))
    json2csv(makeVerbose([...(store.get("abandonedStati") || []).map(item => ParseSingleStringifiedStati(item)), ...store.get('stati')]), (err, csv) => download(`prayer-log-${new Date().toISOString()}.csv`, csv));
}

export const _MS_PER_DAY = 1000 * 60 * 60 * 24;

export function dateDiffInDays(a, b) {
  // Discard the time and time-zone information.
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

  return Math.floor((utc2 - utc1) / _MS_PER_DAY);
}

export function timeGreater(a = "00:00", b = "00:01") {
  if (parseInt(a.split(':')[0]) > parseInt(b.split(':')[0])) return true;
  else if (parseInt(a.split(':')[0]) === parseInt(b.split(':')[0]) && parseInt(a.split(':')[1]) > parseInt(b.split(':')[1])) return true;
  else return false
}

export function timeConvert(time) {
  // Check correct time format and split into components
  time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

  if (time.length > 1) { // If time format correct
    time = time.slice(1);  // Remove full string match value
    time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
  }
  return time.join(''); // return adjusted time or original string
}